import { useNavigate } from 'react-router-dom';

/**
 * Custom hook that handles navigation to the "New Question" page.
 * @returns An object containing the function to handle navigation to the "New Question" page.
 */
const useAskQuestionButton = () => {
  const navigate = useNavigate();

  /**
   * Function to handle navigation to the "New Question" page.
   */
  const handleNewQuestion = () => {
    navigate('/new/question');
  };

  return { handleNewQuestion };
};

export default useAskQuestionButton;
